export default "__VITE_ASSET__4649cd70__"